import { Component, OnInit } from '@angular/core';
import { AlertasModales } from '../../helpers/alertasModales';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CuadreService } from '../../services/cuadre.service';
import { EmpleadosServicio } from '../../services/empleado.service';
import { RutasService } from '../../services/rutas.service';

const ID_PAGINA = 35;

@Component({
  selector: 'app-cobradores-trabajando',
  templateUrl: './cobradores-trabajando.component.html',
  styleUrls: ['./cobradores-trabajando.component.css']
})
export class CobradoresTrabajandoComponent implements OnInit {
  rutas = [];
  multiSelectPrestamos: any;
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  cobradores: any[];
  loaded = false;
  loading = false;
  page = 1;
  limit = 50;
  offset = 0;
  size = 0;
  busqueda = '';

  constructor(
    private rutaService: RutasService,
    private cuadreService: CuadreService,
    private modals: AlertasModales,
    private router: Router,
    private route: ActivatedRoute,
    private empleadoService: EmpleadosServicio
  ) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3
      && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }
    this.initRutas();
    /*if ( localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }*/
  }

  ngOnInit() {
    this.verificarQueryString();
    this.initConfigMultiSelect();
  }

  private initConfigMultiSelect() {
    this.multiSelectPrestamos = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas()
    .subscribe(rutas => {
      for (const ruta of rutas.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: String(ruta.nombre)
        });
      }
    });
  }

  private initEmpleados(): void {
    this.loading = true;
    this.cuadreService.cobradoresTrabajando(
      this.limit,
      this.offset,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.busqueda,
    ).subscribe(res => {
      this.cobradores = res.data;
      this.size = res.total_items;
      this.loaded = true;
      this.loading = false;
    });
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }
        if (params.busqueda) {
          this.busqueda = params.busqueda;
        }
        if (params.limite && !isNaN(params.limite)) {
          this.limit = params.limite;
        }
        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }
        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }
        this.initEmpleados();
      }
    });
  }

  public filtrar() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['busqueda'] = this.busqueda;
    queryParams['limite'] = this.limit;
    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    } else {
      delete queryParams['rutas'];
    }


    this.router.navigate(['./token'], { queryParams: queryParams });
  }

  public loadPage(page: number) {
    this.page = page;
    this.offset = this.limit * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./token'], { queryParams: queryParams });
    this.initEmpleados();
  }

  generarToken(data: any) {
    this.modals.generarTokenEmpleadoNgbModal(data.cobrador, data.ID_EMPLEADO);
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/cobradores-trabajando/cobradores-trabajando.component.ts